import { updateObject } from "../../../../shared";
import {
  globalConstants,
  PAGINATION_DEFAULTS,
  surveyQueuesConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const { GET_SURVEY_QUEUES } = surveyQueuesConstants;

//Default state of activity logs reducer
const initialState = {
  surveyQueuesData: [],
  surveyQueuesPaginationData: {
    ...PAGINATION_DEFAULTS,
  },
};

//Manipulating the state of survey queues based on actions and returning the state
export const surveyQueuesReducer = (state = initialState, action) => {
  if (action.type === GET_SURVEY_QUEUES + SUCCESS) {
    return updateObject(state, {
      surveyQueuesData: action.data.data,
      surveyQueuesPaginationData: action.data.page,
    });
  } else {
    return state;
  }
};
